import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, FlexContainer, Space, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import ShareButton from '../social/share-button';

const VideoDetail = ({ title, author, views, description, thumbnail, shareUrl, videoId }) => (
  <>
    <Typography component="h1" preset="subtitle--large">
      {title}
    </Typography>
    <Space vertical="small">
      <FlexContainer direction="row" justifyContent="space-between" flexWrap="wrap">
        <Space bottom="small">
          <Typography
            preset="button"
            color="dustygrey"
            component="div"
            style={{ flex: 1, minWidth: 272 }}
          >
            <Trans i18nKey="common:by_author" values={{ author: author.name }}>
              By
              {author.name}
            </Trans>
          </Typography>
        </Space>
        <FlexContainer
          direction="row"
          justifyContent="space-between"
          flexWrap="wrap"
          style={{ flexGrow: 0.1 }}
        >
          {views > 0 && (
            <Typography preset="body--small" color="dustygrey" component="div">
              <Trans i18nKey="media:views_label" values={{ viewCount: views }}>
                {`${views} views`}
              </Trans>
            </Typography>
          )}

          <Cushion horizontal="small" component="div">
            <ShareButton
              url={shareUrl}
              title={title}
              description={description}
              imageUrl={thumbnail}
              withText
            />
          </Cushion>
          <a href={`https://www.pitchero.com/tools/media/report-video/${videoId}`}>
            <Typography preset="button" color="primary" lineHeight="22px">
              <Trans i18nKey="media:report_video_label">Report</Trans>
            </Typography>
          </a>
        </FlexContainer>
      </FlexContainer>
    </Space>
    <Typography component="div" preset="body--large" color="black">
      {description}
    </Typography>
  </>
);

VideoDetail.defaultProps = {
  author: {
    id: 0,
    name: '',
  },
  description: null,
  views: null,
};

VideoDetail.propTypes = {
  author: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  description: PropTypes.string,
  shareUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  videoId: PropTypes.number.isRequired,
  views: PropTypes.number,
};

export default VideoDetail;
